import { FileLockIcon, HouseIcon, ShipIcon, UserCogIcon, UserPlusIcon } from '@sailadv/hdata-ui';

import { AppRoutes } from '@/shared/constants/app-routes.constant';

import { UserMenuSection } from '../types/user-menu-navigation.interface';

interface UserMenuNavigationArgs {
	isPlant: boolean;
	management: string;
	hasMultipleEntities: boolean;
	canAccessGroupManagement: boolean;
	isPlatformAdmin: boolean;
}

export const userMenuSections = ({
	isPlant,
	management,
	hasMultipleEntities,
	canAccessGroupManagement,
	isPlatformAdmin,
}: UserMenuNavigationArgs): UserMenuSection[] => [
	{
		label: 'header.user-menu.section.settings',
		links: [
			{ label: 'header.user-menu.profile.label', Icon: UserCogIcon, href: AppRoutes.Profile, show: true },
			{
				label: 'header.user-menu.agreements.settings.label',
				Icon: FileLockIcon,
				href: AppRoutes.AgreementsSettings,
				show: isPlatformAdmin,
			},
		],
	},
	{
		label: 'header.user-menu.section.access',
		links: [
			{
				label: isPlant ? 'header.user-menu.plants.label' : 'header.user-menu.yachts.label',
				Icon: isPlant ? HouseIcon : ShipIcon,
				href: management,
				show: isPlatformAdmin && hasMultipleEntities,
			},
			{
				label: 'header.user-menu.group-management.label',
				Icon: UserPlusIcon,
				href: AppRoutes.GroupManagement,
				show: canAccessGroupManagement,
			},
		],
	},
];
